// extracted by mini-css-extract-plugin
export var blockedMessage = "_bx-3";
export var blockedOverlay = "_bx-1";
export var fadeIn = "_bx-2";
export var hereLink = "_bx-0";
export var slideUp = "_bx-4";